import { render } from "./LightIcon.vue?vue&type=template&id=eebf44bc"
const script = {}

import exportComponent from "/Users/mustafatofur/Desktop/Work/ProjectCountMap/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__